export enum ExternalEvent {
  CloseBorrowerPlatform = "bp-close-borrower-platform",
  StartLendflowResumeWidget = "bp-start-widget",
}

export const useEvents = () => {
  const emitExternally = <TData>(eventName: ExternalEvent, data?: TData) => {
    window.parent.postMessage({ eventName, data }, "*");
  };

  return { emitExternally };
};
